/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  RemoveAffiliateReferrerOptions,
  RemoveAffiliateReferrerResponses,
} from '../types/RemoveAffiliateReferrer'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description ADMIN, INTEGRATOR, or AFFILIATE_MANAGER required within tenant and assignment scope. Disables the referrer's code for new attributions while preserving historical attribution and reporting.
 * @summary Remove a referrer from a program
 * {@link /v1/affiliate_programs/:program_id/referrers/:referrer_id}
 */
export function removeAffiliateReferrer<ThrowOnError extends boolean = true>(
  options: Options<RemoveAffiliateReferrerOptions, ThrowOnError>,
): Unwrappable<RequestResult<RemoveAffiliateReferrerResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'DELETE',
      url: '/v1/affiliate_programs/{program_id}/referrers/{referrer_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<RemoveAffiliateReferrerResponses, ThrowOnError>>,
  )
}
